import { render, staticRenderFns } from "./typings.component.vue?vue&type=template&id=3e66d048&scoped=true&"
import script from "./typings.component.vue?vue&type=script&lang=js&"
export * from "./typings.component.vue?vue&type=script&lang=js&"
import style0 from "./typings.component.vue?vue&type=style&index=0&id=3e66d048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e66d048",
  null
  
)

export default component.exports